export default "__VITE_ASSET__f0b89029__"